import { useCallback, useState } from "react";

export const useNotTooFast = (minTime) => {
    const [lastActionDate, setLastActionDate] = useState(0);
    const checkNotTooFast = useCallback(() => {
        // avoid toggling too fast
        if (Date.now() - lastActionDate < minTime) {
            return false;
        }
        setLastActionDate(Date.now());
        return true;
    }, [lastActionDate, setLastActionDate, minTime]);
    return checkNotTooFast;
};